import {SearchSupplier} from "../search-supplier";

export class SearchSupplierWrapper{
 filtersMap : {[key:string]:SearchSupplier}= {};
}
